import React from 'react';
import { useHistory } from 'react-router';
import { Result, Button } from 'antd';

const Index = () => {
    const history = useHistory()
    return (
        <div style={{ minHeight: '100vh' }}>
            <Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
                extra={<Button type="primary" onClick={() => history.push('/')} >Back Home</Button>}
            />
        </div>
    )
}

export default Index
